import { useFunds } from 'hooks/data/fund/useFunds';
import { useGetRole } from './useGetRole';
import { useFirm } from 'hooks/data/firm/useFirm';
import {
  createEisSidebarNav,
  createLpSidebarNav,
  MenuItemType,
} from 'helpers/layout/sidebarMenu';
import {
  FIRM,
  createFirmEditRoute,
  createOpenTrancheRoute,
  createSingleFirmRoute,
} from 'adminConstants/routes';
import { AdminUserRealm } from 'further-types/admin-user';

export type SidebarMenuItemType = MenuItemType;

export default function useSidebarMenuItems(realm?: AdminUserRealm) {
  const { firmId } = useGetRole();
  const isEisOrSuperRealm =
    realm === AdminUserRealm.Eis || realm === AdminUserRealm.Super;

  const { tranches } = useFunds({
    fundStatus: 1,
    leanResponse: true,
    disabled: !isEisOrSuperRealm,
  });
  const { firms } = useFirm({ params: { disabled: !isEisOrSuperRealm } });

  if (realm === AdminUserRealm.Lp) {
    return createLpSidebarNav();
  }

  if (isEisOrSuperRealm) {
    const myFirmLink = firmId ? createFirmEditRoute(firmId) : FIRM;

    if (!tranches.data?.length) {
      return createEisSidebarNav(myFirmLink);
    }

    const openTrancheDashboardLinks = (tranches.data ?? []).map((fund) => ({
      name: `${fund.firmId.firmName} ${fund.fundName}`,
      type: 'item',
      link: createOpenTrancheRoute(fund?._id),
    }));

    if (firmId) {
      return createEisSidebarNav(myFirmLink, openTrancheDashboardLinks);
    }

    if (!firms.data?.result?.length) {
      return createEisSidebarNav(myFirmLink);
    }

    const firmDashboardLinks = firms.data.result.map((firm) => ({
      name: firm.firmName,
      type: 'item',
      link: createSingleFirmRoute(firm?._id),
    }));

    return createEisSidebarNav(
      myFirmLink,
      openTrancheDashboardLinks,
      firmDashboardLinks,
    );
  }
}
